import { render, staticRenderFns } from "./add-certificate.vue?vue&type=template&id=6d31a238&scoped=true&"
import script from "./add-certificate.vue?vue&type=script&lang=js&"
export * from "./add-certificate.vue?vue&type=script&lang=js&"
import style0 from "./add-certificate.vue?vue&type=style&index=0&id=6d31a238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31a238",
  null
  
)

export default component.exports